import { useState } from "react";
import { useAtom } from "jotai";
import useLeadAutoList, { leadAutoFiltersAtom } from "../useLeadAutoList";
import { LEAD_AUTO_FILTERS_DEFAULT } from "../leadAutoFiltersDefault";
import {
  PERIOD_SHORTCUTS_AUTO,
  isPresetActive,
  emptyPatchFor,
} from "./leadAutoPresets";

// Logique de la cartouche de filtres auto (PER-2410), pendant de
// LeadListFilters/useLeadFilters côté entreprise, écrite pour l'état à plat.
const useLeadAutoFilters = () => {
  const [leadAutoFilters, setLeadAutoFilters] = useAtom(leadAutoFiltersAtom);
  const { actions: listActions } = useLeadAutoList();
  const [showExpiredManagers, setShowExpiredManagers] = useState(false);

  // Modifie un champ sans chercher (champ de recherche, tiroir) : la
  // recherche part au submit, comme aujourd'hui.
  const updateFilter = (name, value) =>
    listActions.onFiltersChange({ [name]: value });

  // Même chose pour plusieurs champs à la fois (segment « Étape »).
  const updateFilters = (patch) => listActions.onFiltersChange(patch);

  // Applique un patch et cherche tout de suite, avec la valeur calculée ici —
  // jamais l'état du rendu courant, qui est celui d'avant le clic.
  const applyAndSearch = (patch) => {
    const next = { ...leadAutoFilters, ...patch, page: 1 };
    setLeadAutoFilters(next);
    listActions.onFetchLeadAutoList(next);
  };

  // Presets exclusifs : re-cliquer le preset actif remet ses champs à vide.
  const applyPreset = (preset, ctx) => {
    const patch = preset.build(ctx);
    applyAndSearch(
      isPresetActive(preset, leadAutoFilters, ctx) ? emptyPatchFor(patch) : patch,
    );
  };

  // Activité d'un preset donné, évaluée indépendamment des autres : deux
  // presets aux champs disjoints peuvent être actifs en même temps.
  const isPresetOn = (preset, ctx) => isPresetActive(preset, leadAutoFilters, ctx);

  const removeFilterToken = (clearPatch) => applyAndSearch(clearPatch);

  const clearAllFilters = () => {
    const fresh = { ...LEAD_AUTO_FILTERS_DEFAULT };
    setLeadAutoFilters(fresh);
    listActions.onFetchLeadAutoList(fresh);
  };

  const setPeriodShortcut = (shortcutId) => {
    const shortcut = PERIOD_SHORTCUTS_AUTO.find((s) => s.id === shortcutId);
    if (shortcut) applyAndSearch(shortcut.build());
  };

  const toggleShowExpiredManagers = () => setShowExpiredManagers((v) => !v);

  return {
    leadAutoFilters,
    showExpiredManagers,
    actions: {
      updateFilter,
      updateFilters,
      applyAndSearch,
      applyPreset,
      isPresetOn,
      removeFilterToken,
      clearAllFilters,
      setPeriodShortcut,
      toggleShowExpiredManagers,
    },
  };
};

export default useLeadAutoFilters;
